import { useEffect, useMemo, useState } from 'react';

import { retrieve } from '../../../apis/address';
import { STRINGS } from '../../../constants';
import { AddressHelpers } from '../../../helpers';
import { buildCitysprintAddressForWidget } from '../helpers';

export function useCitysprintAddressForWidget(kind, booking, form) {
  const base = useMemo(
    () => buildCitysprintAddressForWidget(kind, booking, form),
    [kind, booking, form]
  );
  const [address, setAddress] = useState(base);
  const addressId =
    kind === 'delivery'
      ? booking?.delivery?.addressId
      : booking?.collection?.addressId;

  useEffect(() => {
    setAddress(base);
  }, [base]);

  useEffect(() => {
    if (base._coordinates || !addressId) {
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await retrieve({
          key: addressId,
          countryISO: STRINGS.GB,
        });
        const fullAddress = response?.Item?.[0];
        const coords = AddressHelpers.formatCoordinates(fullAddress);
        if (!cancelled && coords) {
          setAddress(current => ({ ...current, _coordinates: coords }));
        }
      } catch {
        // Keep the static fallback map when coordinates cannot be resolved.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [addressId, base._coordinates]);

  return address;
}
